import { render, staticRenderFns } from "./label_detail.vue?vue&type=template&id=247772ec&scoped=true&"
import script from "./label_detail.vue?vue&type=script&lang=js&"
export * from "./label_detail.vue?vue&type=script&lang=js&"
import style0 from "./label_detail.vue?vue&type=style&index=0&id=247772ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247772ec",
  null
  
)

export default component.exports